import React, { useContext } from "react";
import { Select, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import intl from "react-intl-universal";

import { UserContext, IUserContext } from "context/user";
import { ITeam } from "apis";
import { setDefaultTeam as setDefaultTeamLocally } from "utils/localStorage";

const useStyles = makeStyles(() => ({
  select: {
    "&.MuiInput-underline:before": {
      borderBottom: "1px solid rgb(250, 250, 250)",
    },
    "&.MuiInputBase-root": {
      color: "white",
    },
  },
  icon: {
    fill: "white",
  },
}));

export const TeamSelector = () => {
  const classes = useStyles();
  const { teams, defaultTeam, setDefaultTeam }: IUserContext = useContext(
    UserContext
  );

  return (
    <Select
      className={classes.select}
      color="secondary"
      value={teams && teams.length > 0 ? defaultTeam : -1}
      inputProps={{
        classes: {
          icon: classes.icon,
        },
      }}
      onChange={(event) => {
        const teamId: number = event.target.value as number;
        setDefaultTeamLocally(teamId);
        setDefaultTeam(teamId);
      }}
    >
      <MenuItem disabled value={-1}>
        {intl.get("TEAM_SELECTOR_PROMPT_OPTION")}
      </MenuItem>
      {teams.map((team: ITeam) => (
        <MenuItem value={team.id} key={team.id}>
          {team.name}
        </MenuItem>
      ))}
    </Select>
  );
};
